import type { ICellRendererParams } from 'ag-grid-enterprise';
import { useEffect, useRef } from 'react';
import { IconButton } from '../Button';
import { Box } from '../Core';
import { FormControlSizes } from '../Form/types';
import { IconName } from '../Icons';
import type { WatchListRowData } from './types';

export interface ReorderCellRendererParams extends ICellRendererParams {
  data: WatchListRowData;
}

export const ReorderCellRenderer = function ReorderCellRenderer({
  data,
  registerRowDragger,
}: ReorderCellRendererParams) {
  const draggerRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const el = draggerRef.current;
    if (!el) {
      return;
    }
    registerRowDragger(el, undefined, data.security.DisplaySymbol, true);
  }, [registerRowDragger, data.security.DisplaySymbol]);

  return (
    <Box display="flex" alignItems="center" justifyContent="center" h="100%" w="100%">
      <IconButton
        ref={draggerRef}
        data-testid="watchlist-reorder"
        dim
        ghost
        icon={IconName.DragVertical}
        size={FormControlSizes.Small}
        aria-label="Reorder row"
        style={{ cursor: 'grab' }}
      />
    </Box>
  );
};
